module.exports = __webpack_public_path__ + "img/ottolinger-logo-2020-blk100.d5623839.png";